import { Drawer as RMWCDrawer, DrawerContent as RMWCDrawerContent, DrawerProps as RMWCDrawerProps } from "@rmwc/drawer";
import React, { FC } from "react";

import "@material/drawer/dist/mdc.drawer.css";

import "./style.nomodule.scss";

interface DrawerProps extends RMWCDrawerProps {
    children: any;
    type?: "left" | "right";
    hideOverlay?: boolean;
}

const Drawer: FC<DrawerProps> = (props: DrawerProps) => {
    const { children, hideOverlay, type, ...drawerProps } = props;
    const direction = type === "right" ? "rtl" : "ltr";
    const additionalClassNames = hideOverlay ? "mdc-modal--no_overlay" : undefined;

    return (
        <RMWCDrawer className={additionalClassNames} dir={direction} {...drawerProps}>
            {/* regardless of which side of the screen the drawer is pinned to, we want the content to flow left to right */}
            <RMWCDrawerContent dir="ltr">{children}</RMWCDrawerContent>
        </RMWCDrawer>
    );
};

export { Drawer, DrawerProps };
